export const createArr = (length: number, value?: any) => {
  return new Array(length).fill(value ?? '')
}
